import { render, staticRenderFns } from "./AndroidWalletOpenButton.vue?vue&type=template&id=fc09ea8a&scoped=true&"
var script = {}
import style0 from "./AndroidWalletOpenButton.vue?vue&type=style&index=0&id=fc09ea8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc09ea8a",
  null
  
)

export default component.exports